import React from 'react';
import { BrandText } from 'design-comuni-plone-theme/components/ItaliaTheme';

const BrandTextFooter = () => {
  return <BrandText getParent={true} />;
};

export default BrandTextFooter;
